export default __webpack_public_path__ + "static/media/main-landing.c419737d.png";